<template lang="pug">
.marketing-upload-contract-and-do(v-loading="loading")
  title-bar {{ $t('合同') }}
  template(v-if="!contractResult")
    .marketing-upload-contract-and-do_form(v-if="currentTask && currentTask.can_view")
      el-row
        el-col.required(:span="2") {{ $t('DO号') }}
        el-col(:span="20")
          el-input(v-model="contract.do_number")
      el-row
        el-col.required(:span="2") {{ $t('合同号') }}
        el-col(:span="20")
          el-input(v-model="contract.contract_no")
      el-row
        el-col.required(:span="2") {{ $t('合同') }}
        el-col(:span="20")
          .file_container
            new-upload-file(
              axiosUrl="/management/subfinal/saveFile"
              :params="uploadParams"
              @loadingChange="status => loading = status"
              @uploadSuccess="uploadSuccess"
            )
            a(
              v-if="contract.contract_download_path"
              :href="contract.contract_download_path"
              traget="_blank"
            ) {{ contract.contract_name }}
      el-row
        el-col(:offset="2" :span="10")
          footer-button(
            @confirm="submit"
            @cancel="$router.push('/unistar/campaign-overview')"
          )
    .no-data(v-else) {{ $t('待确认') }}
  .info-display( v-else)
    el-row
      el-col(:span="24")
        .info_label {{ $t('DO号') }}
        .info_content {{ contractResult.do_no }}
    el-row
      el-col(:span="24")
        .info_label {{ $t('合同号') }}
        .info_content {{ contractResult.contract_no }}
    el-row
      el-col(:span="24")
        .info_label {{ $t('合同') }}
        .info_content
          a(
            v-if="contractResult.download_url"
            :href="contractResult.download_url"
            traget="_blank"
          ) {{ contractResult.file_name }}
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import NewUploadFile from '@/components/NewUploadFile'
import { format4backend } from '@/umcc/util'
export default {
  data () {
    return {
      loading: false,
      contract: {
        do_number: '',
        contract_no: '',
        contract_name: '',
        contract_path: '',
        contract_download_path: ''
      },
      contractResult: null
    }
  },
  components: {
    TitleBar,
    FooterButton,
    NewUploadFile
  },
  mounted () {
    this.getSowContract()
  },
  methods: {
    getSowContract () {
      this.loading = true
      axios.get('/management/star/getSowContract', {
        params: {
          campaign_id: this.campaignInfo.campaignId,
          sub_final_scope_id: this.sowInfo.sub_final_scope_id
        }
      }).then(res => {
        this.loading = false
        if (res[0]) {
          this.contractResult = res[0]
        }
      })
    },
    submit () {
      if (!this.contract.do_number || !this.contract.contract_no || !this.contract.contract_path) {
        this.$message.error(this.$t('请填写必填项'))
        return
      }
      if (this.contract.do_number.length > 20 || this.contract.contract_no.length > 20) {
        this.$message.error(this.$t('DO号/合同号长度超出限制'))
        return
      }
      let params = {
        campaign_id: this.campaignInfo.campaign_id,
        sub_final_scope_id: this.sowInfo.sub_final_scope_id,
        task_id: this.currentTask.taskId,
        sub_final_scope_contract: [
          {
            sub_final_scope_id: this.sowInfo.sub_final_scope_id,
            do_no: this.contract.do_number,
            contract_no: this.contract.contract_no,
            contract_path: this.contract.contract_path
          }
        ]
      }
      this.loading = true
      axios.post('/management/star/saveSowContract', format4backend(params)).then(res => {
        this.getSowContract()
        this.$store.dispatch('unistar/getCampaignInfo')
        this.$store.dispatch('unistar/getProcessTasks', {
          business_key: this.sowInfo.sub_final_scope_id,
          business_type: this.sowInfo.business_type,
          phase_type: 2
        })
        this.loading = false
      })
    },
    uploadSuccess (res) {
      this.contract.contract_path = res.file_path
      this.contract.contract_name = res.file_name
      this.contract.contract_download_path = res.file_download_path
      this.loading = false
    }
  },
  computed: {
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    },
    campaignInfo () {
      return this.$store.state.unistar.campaignInfo
    },
    currentTask () {
      return this.$store.state.unistar.sowProcess.find(task => this.$route.path.includes(task.action))
    },
    uploadParams () {
      return {
        campaign_id: this.campaignInfo.campaign_id,
        file_type: 4
      }
    }
  }
}
</script>

<style lang="stylus">
.marketing-upload-contract-and-do
  .marketing-upload-contract-and-do_form
    margin-left 20px
    .io_numbers
      margin-bottom 10px
      .el-button
        margin-left 5px
    .el-input
      width 200px
    .file_container
      display flex
      align-items center
      a
        margin-left 15px
  .no-data
    height 300px
    width 100%
    display flex
    justify-content center
    align-items center
    color #e0e0e0
    font-size 40px
</style>
